module.exports = __webpack_public_path__ + "img/s00167.8c560c22.png";